export default __webpack_public_path__ + "static/media/xsushi-text-sign.1c4cf7e1.png";